import { useState, useEffect } from 'react';
import { createTheme } from "@mui/material";
import './App.css';
import { auth } from "./config/firebase";
import AuthChecker from "./components/auth/AuthChecker";
import PrimaryNavBar from './components/PrimaryNavBar';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import MatchCreate from './pages/Matches/MatchCreate';
import MatchJoin from './pages/Matches/MatchJoin';
import Home from './pages/Home';
import Login from './pages/Login';
import Profile from './pages/Profile';
import MatchAdmin from './pages/Matches/MatchAdmin';
import Match from './pages/Matches/Match';
import "dseg/css/dseg.css";
import StackmatChecker from './components/StackmatChecker';
import OverlayRoot from './overlays/OverlayRoot';
import { CreateOrganizationForm } from './pages/Organization/CreateOrganizationForm';
import { EditOrganizationPage } from './pages/Organization/EditOrganizationPage';
import { OrgThemeProvider } from './components/OrgThemeProvider';
import { OrgProvider } from './components/OrgContext';
import { BluetoothCubeProvider } from './components/BluetoothCubeProvider';
import { StackmatTimerTestPage } from './pages/StackmatTestPage';


function App() {
  const [loading, setLoading] = useState(true);

  const theme = createTheme({
    palette: {
      primary: {
        main: '#ffad48',
        // light: will be calculated from palette.primary.main,
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      },
      secondary: {
        main: '#506180',
        light: '#F5EBFF',
        // dark: will be calculated from palette.secondary.main,
      },
    },
  });

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      if (user) {
        console.info("User detected.");
      } else {
        console.info("No user detected");
      }
      setLoading(false);
    });
  }, []);

  return (
    <OrgProvider>
      <OrgThemeProvider>
        
          {/* <BrowserRouter basename={process.env.PUBLIC_URL}> */}
          {/*<RouterProvider router={router} />*/}
          <BrowserRouter>
            <Routes>
              <Route path="/stackmat" element={
                <BluetoothCubeProvider>
                  <StackmatTimerTestPage />
                </BluetoothCubeProvider>
              } />
              <Route path="/matches/:id" element={

                <AuthChecker>
                  <PrimaryNavBar />
                  <BluetoothCubeProvider>
                    <Match />
                  </BluetoothCubeProvider>
                </AuthChecker>

              } />
              <Route path="/matches/:id/admin" element={
                <AuthChecker requiresAdmin={true}>
                  <PrimaryNavBar />
                  <MatchAdmin />
                </AuthChecker>
              } />
              <Route path="/organizations/create" element={
                <AuthChecker requiresAdmin={true}>
                  <PrimaryNavBar />
                  <CreateOrganizationForm />
                </AuthChecker>
              } />
              <Route path="/organizations/:orgId/edit" element={
                <AuthChecker requiresAdmin={true}>
                  <PrimaryNavBar />
                  <EditOrganizationPage />
                </AuthChecker>
              } />
              <Route path="/matches/:id/overlay" element={
                <OverlayRoot />
              } />
              <Route path="/stream/:id" element={
                <OverlayRoot />
              } />
              <Route path="/matches/create" element={
                <AuthChecker requiresAdmin={true}>
                  <PrimaryNavBar />
                  <MatchCreate />
                </AuthChecker>
              } />
              <Route path="/join" element={
                <AuthChecker>
                  <PrimaryNavBar />
                  <MatchJoin />
                </AuthChecker>
              } />
              <Route path="/profile" element={
                // <BluetoothCubeProvider>
                <AuthChecker>
                  <PrimaryNavBar />
                  <BluetoothCubeProvider>
                    <Profile />
                  </BluetoothCubeProvider>
                </AuthChecker>
                // </BluetoothCubeProvider>
              } />
              <Route path="/" element={
                <AuthChecker>
                  <PrimaryNavBar />
                  <Home />
                </AuthChecker>
              } />
              <Route path="/login" element={<Login />} />
            </Routes>
          </BrowserRouter>
      </OrgThemeProvider>
    </OrgProvider>
  );
}

export default App;
